import { useSelector, useDispatch } from 'react-redux';
import { ReduxState } from '../types';
import { setSelectedYear } from '../actions/yearActions';

export const useYear = () => {
  const dispatch = useDispatch();
  const selectedYear = useSelector((state: ReduxState) => state.year.selectedYear);

  const changeYear = (year: number) => {
    dispatch(setSelectedYear(year));
  };

  const getAvailableYears = () => {
    const currentYear = new Date().getFullYear() + 1;
    const years = [];
    for (let year = 2024; year <= currentYear; year += 1) {
      years.push(year);
    }
    return years;
  };

  return {
    selectedYear,
    changeYear,
    getAvailableYears,
  };
};

export default useYear;
